module.exports = __webpack_public_path__ + "static/media/confused-pound-dark.218b1589.svg";